export default __webpack_public_path__ + "static/media/rebidding_icon.3b00bcc4.svg";